import { MultiSelectDropdown } from "@visiblethread/react-components";
import { array, func, string } from "prop-types";

import classes from "../../shared/fields/FieldRow.module.scss";
import RemoveButton from "../../shared/fields/RemoveButton";
import { formDataPropType } from "../propTypes";

const MultiSelectField = ({
  formData,
  onDisable,
  onValueChange,
  fieldId,
  labelText,
  placeholder = "Select ...",
  options = [],
}) => {
  return (
    <>
      {formData[fieldId] !== null && (
        <div className={classes.formRow}>
          <div className={classes.formRow__field}>
            <label htmlFor={fieldId}>{labelText}</label>
            <MultiSelectDropdown
              searchable
              placeholder={placeholder}
              options={options}
              values={formData[fieldId]}
              onSelect={onValueChange(fieldId)}
              className={classes.formRow__dropdown}
            />
          </div>
          <div className={classes.formRow__disableButton}>
            <RemoveButton onClick={onDisable(fieldId)} />
          </div>
        </div>
      )}
    </>
  );
};

export default MultiSelectField;

MultiSelectField.propTypes = {
  formData: formDataPropType.isRequired,
  onDisable: func.isRequired,
  onValueChange: func.isRequired,
  fieldId: string.isRequired,
  placeholder: string,
  labelText: string.isRequired,
  options: array,
};
